'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setMultipleLimits = exports.getTableGamesSummary = exports.getLimitWithToken = exports.setLimitWithToken = exports.pgsiScore = exports.panic = exports.getProductBlocks = exports.blockProduct = exports.decline = exports.confirm = exports.toConfirm = exports.selfBlock = exports.selfExclude = exports.getRealityCheckData = exports.getRealityCheckSession = exports.deleteLimit = exports.setLimit = exports.getLimit = exports.limitIncreaseInfo = undefined;

var _utils = require('./utils');

var limitIncreaseInfo = exports.limitIncreaseInfo = function limitIncreaseInfo(playerSessionID) {
  return (0, _utils.getProtected)('/responsiblegaming/limit-increase-info', playerSessionID);
};

var getLimit = exports.getLimit = function getLimit(playerSessionID) {
  return (0, _utils.getProtected)('/responsiblegaming/limit', playerSessionID);
};

var setLimit = exports.setLimit = function setLimit(playerSessionID, data) {
  return (0, _utils.postProtected)('/responsiblegaming/limit', playerSessionID, data);
};

var deleteLimit = exports.deleteLimit = function deleteLimit(playerSessionID, limitID, score) {
  score = typeof score !== 'undefined' ? '?pgsiScore=' + score : '';
  return (0, _utils.postProtected)('/responsiblegaming/limit/cancel/' + limitID + score, playerSessionID);
};

var getRealityCheckSession = exports.getRealityCheckSession = function getRealityCheckSession(playerSessionID) {
  return (0, _utils.getProtected)('/responsiblegaming/session', playerSessionID);
};

var getRealityCheckData = exports.getRealityCheckData = function getRealityCheckData(playerSessionID) {
  return (0, _utils.getProtected)('/responsiblegaming/realitycheck-data', playerSessionID);
};

var selfExclude = exports.selfExclude = function selfExclude(playerSessionID, expiresIn) {
  return (0, _utils.postProtected)('/responsiblegaming/self-exclude/' + expiresIn, playerSessionID);
};

var selfBlock = exports.selfBlock = function selfBlock(playerSessionID, expiresIn) {
  return (0, _utils.postProtected)('/responsiblegaming/block/' + expiresIn, playerSessionID);
};

var toConfirm = exports.toConfirm = function toConfirm(playerSessionID) {
  return (0, _utils.getProtected)('/responsiblegaming/limit/to-confirm', playerSessionID);
};

var confirm = exports.confirm = function confirm(playerSessionID, id) {
  return (0, _utils.postProtected)('/responsiblegaming/limit/confirm/' + id, playerSessionID);
};

/**
 * declining waiting-for-confirmation of Game's Limitation
 * URL: /account/responsible-gaming
 * doc: http://api.preprod.aleacc.com/swagger/ui/index#!/ResponsibleGaming/ResponsibleGaming_DeclineLimit
 * @param playerSessionID
 * @param id
 * @returns {*}
 */
var decline = exports.decline = function decline(playerSessionID, id) {
  return (0, _utils.postProtected)('/responsiblegaming/limit/decline/' + id, playerSessionID);
};

var blockProduct = exports.blockProduct = function blockProduct(playerSessionID, expiresIn, product) {
  return (0, _utils.postProtected)('/responsiblegaming/block-product/' + expiresIn, playerSessionID, product);
};

var getProductBlocks = exports.getProductBlocks = function getProductBlocks(playerSessionID) {
  return (0, _utils.getProtected)('/responsiblegaming/product-blocks', playerSessionID);
};

var panic = exports.panic = function panic(playerSessionID, panicChoice) {
  return (0, _utils.postProtected)('/responsiblegaming/panic', playerSessionID, panicChoice);
};

var pgsiScore = exports.pgsiScore = function pgsiScore(playerSessionID, Score) {
  return (0, _utils.postProtected)('/responsiblegaming/pgsi-score', playerSessionID, Score);
};

var setLimitWithToken = exports.setLimitWithToken = function setLimitWithToken(limit) {
  return (0, _utils.post)('/responsiblegaming/limit/set-with-token', limit);
};

var getLimitWithToken = exports.getLimitWithToken = function getLimitWithToken(token) {
  return (0, _utils.get)('/responsiblegaming/limit/get-with-token/?token=' + token);
};

var getTableGamesSummary = exports.getTableGamesSummary = function getTableGamesSummary(playerSessionID) {
  return (0, _utils.getProtected)('/responsiblegaming/table-games-summary', playerSessionID);
};

var setMultipleLimits = exports.setMultipleLimits = function setMultipleLimits(playerSessionID, data) {
  return (0, _utils.postProtected)('/responsiblegaming/limit/multiple-limits', playerSessionID, data);
};

exports.default = {
  getLimit: getLimit,
  getRealityCheckSession: getRealityCheckSession,
  getRealityCheckData: getRealityCheckData,
  setLimit: setLimit,
  deleteLimit: deleteLimit,
  pgsiScore: pgsiScore,
  selfBlock: selfBlock,
  selfExclude: selfExclude,
  toConfirm: toConfirm,
  confirm: confirm,
  decline: decline,
  blockProduct: blockProduct,
  getProductBlocks: getProductBlocks,
  panic: panic,
  limitIncreaseInfo: limitIncreaseInfo,
  setLimitWithToken: setLimitWithToken,
  getLimitWithToken: getLimitWithToken,
  getTableGamesSummary: getTableGamesSummary,
  setMultipleLimits: setMultipleLimits
};